import { classifyFreshness, type FacilityInformation, type Freshness } from "@predoc/domain";

export function emergencyFreshness(information: FacilityInformation["emergency"], now: Date): Freshness | null {
  if (information === null) return null;
  const states = [information.freshness, classifyFreshness(information.fetchedAt, now), classifyFreshness(information.observedAt, now)];
  return (["UNAVAILABLE", "EXPIRED", "DELAYED", "RECENT"] as const).find((value) => states.includes(value)) ?? "UNAVAILABLE";
}

export function FacilityAvailability({ information, beds, now }: { information: FacilityInformation["emergency"]; beds: number | null; now: Date }): React.JSX.Element | null {
  const freshness = emergencyFreshness(information, now);
  if (information === null) return null;
  const current = freshness === "RECENT";
  return <section className="facility-availability" aria-label="응급실 병상 현황">
    {current && beds !== null ? <>
      <p><strong>응급실 가용병상 {beds}개</strong></p>
      <small>{new Intl.DateTimeFormat("ko-KR", { hour: "2-digit", minute: "2-digit", timeZone: "Asia/Seoul" }).format(new Date(information.observedAt!))} 보고 기준</small>
      <p>병상 수는 진료·수용 가능 여부를 보장하지 않습니다.</p>
    </> : <p>{current ? "응급실 병상 수 미제공" : freshness === "DELAYED" ? "응급실 병상 현황 갱신 지연" : "응급실 병상 현황 미확인"}</p>}
  </section>;
}
